import React, { useState } from "react";
import { useStateContext } from "../../contexts/ContextProvider";

import Attachment from "../../assets/images/attachment.svg";

import ProbationCircle from "../../assets/images/probationCircle.svg";
import FullTimeCircle from "../../assets/images/fullTimeCircle.svg";

import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { Form } from "react-bootstrap";
import CompanyPolicyService from "../../services/companyPolicy.service";

import { Calendar } from "primereact/calendar";
import "primereact/resources/themes/lara-light-cyan/theme.css";

import moment from "moment";

const AddPolicy = ({ fetchAllPolicies }) => {
  const { policy, setPolicy } = useStateContext();

  const [validated, setValidated] = useState(false);

  const initialData = {
    title: "",
    description: "",
    attachment: "",
    applicableFor: "",
    effectiveOn: "",
    formatedDate: "",
  };

  const [details, setDetails] = useState(initialData);

  const [date, setDate] = useState();

  const handleChangeDate = (e) => {
    setDate(e.value);
    setDetails({
      ...details,
      effectiveOn: moment(new Date(e.value)).format("YYYY-MM-DD"),
      formatedDate: moment(new Date(e.value)).format("D MMM YYYY"),
    });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "applicableFor") {
      if (e.target.checked) {
        setDetails({ ...details, [name]: value });
      }
    } else {
      setDetails({ ...details, [name]: value });
    }
  };

  const handleFileChange = (e) => {
    setDetails({ ...details, attachment: e.target.files[0] });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    e.stopPropagation();

    const form = e.currentTarget;

    if (form.checkValidity() === false) {
      setValidated(true);
      toast.warn("* Please fill all required fields!", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      return;
    }

    const formData = new FormData();
    formData.append("title", details.title);
    formData.append("description", details.description);
    formData.append("attachment", details.attachment);
    formData.append("attchdoc", "");
    formData.append("applicableFor", details.applicableFor);
    formData.append("effectiveOn", details.effectiveOn);

    // console.log("details", details);

    CompanyPolicyService.insertCompanyPolicy(formData)
      .then((resp) => {
        if (resp.data.errors) {
          toast.warn("Company Policy not Added", {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
        } else {
          fetchAllPolicies();
          toast.success("Company Policy Added Successfully", {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
        }
        setPolicy(false);
      })
      .catch((e) => console.log(e));
  };

  return (
    <>
      <div
        className={`${
          policy
            ? "add-event feedback policy visible"
            : "add-event feedback policy hidden"
        }`}
      >
        <div className="flex mb-5">
          <div className="left-flex mb-4">
            <span>Add New Policy </span>
          </div>
          <Form noValidate validated={validated} onSubmit={handleSubmit}>
            <div className="event-form scroll">
              <div className="mb-3">
                <label htmlFor="" className="form-label">
                  Add Policy Name *
                </label>
                <input
                  type="text"
                  className="form-control"
                  name="title"
                  value={details.title}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="mb-3">
                <label htmlFor="" className="form-label">
                  Add Information/Details about policy
                </label>
                <textarea
                  name="description"
                  value={details.description}
                  onChange={handleChange}
                ></textarea>
              </div>
              <div className="mb-3 calendar-relative">
                <label htmlFor="leaveType" className="form-label">
                  Effective On *
                </label>
                <Calendar
                  value={date}
                  onChange={handleChangeDate}
                  view="date"
                  dateFormat="dd, MM, yy"
                  style={{ width: "100%", height: "45px" }}
                  showIcon
                  // disabledDays={[0, 6]}
                  selectOtherMonths
                  required
                />
              </div>
              <div className="attachment mb-3">
                <span>
                  <input
                    type="file"
                    name="attachment"
                    onChange={handleFileChange}
                    required
                  />
                </span>
                <span>
                  <img src={Attachment} alt="" />
                </span>
                <span>Attach Documents *</span>
                <small>File Types: pdf, jpeg, png, word </small>
              </div>
              <div className="mb-3">
                <label htmlFor="" className="form-label">
                  This policy is for?
                </label>
                <div className="statusFilter-flex2">
                  <div className="sort-flex">
                    <div className="">
                      <img src={ProbationCircle} alt="" />
                      <span className="status-filter">Probation</span>
                    </div>
                    <label className="checkbox-container">
                      <input
                        type="radio"
                        name="applicableFor"
                        value="0"
                        id="probation"
                        checked={details.applicableFor === "0"}
                        onChange={handleChange}
                      />
                      <span className="checkmark"></span>
                    </label>
                  </div>
                  <div className="sort-flex">
                    <div className="">
                      <img src={FullTimeCircle} alt="" />
                      <span className="status-filter">Full Time</span>
                    </div>

                    <label className="checkbox-container">
                      <input
                        type="radio"
                        name="applicableFor"
                        value="1"
                        id="fullTime"
                        checked={details.applicableFor === "1"}
                        onChange={handleChange}
                      />
                      <span className="checkmark"></span>
                    </label>
                  </div>
                </div>
              </div>
            </div>

            <div className="sort-action">
              <button
                className="btn btn-reset"
                onClick={(e) => {
                  setPolicy(false);
                }}
              >
                Reset
              </button>
              <button className="btn btn-apply">Add</button>
            </div>
          </Form>
        </div>
      </div>
    </>
  );
};

export default AddPolicy;
